export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_17.cac34d05.jpg";